export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="font-heading font-bold text-xl text-background-50 mb-4 block">
              羞羞羞漫画
            </span>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              免费漫画在线阅读平台，汇聚热门韩漫、日漫、国漫全集大全，支持下拉式阅读，每日同步追更，永久免费。
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon, idx) => (
                <div key={idx} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className={`${icon} text-sm`}></i>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门专题', href: '#carousel' },
                { label: '人气排行', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '漫画分类', href: '#index' },
                { label: '最新快讯', href: '#updates' },
              ].map((link, idx) => (
                <a
                  key={idx}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: 'APP下载', href: '#app' },
                { label: '读者评价', href: '#comments' },
                { label: '关于我们', href: '#about' },
              ].map((link, idx) => (
                <a
                  key={idx}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              期待与更多优秀的内容创作者、漫画工作室和品牌方建立合作关系。如有合作意向，欢迎通过联系我们页面与我们沟通交流。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-400">
            <p>© 2024 羞羞羞漫画 · 保留所有权利</p>
            <div className="flex items-center gap-4">
              <span className="cursor-pointer hover:text-background-50 transition-colors whitespace-nowrap">用户协议</span>
              <span className="cursor-pointer hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</span>
              <span className="cursor-pointer hover:text-background-50 transition-colors whitespace-nowrap">版权声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}